var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentalHealthNewIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88031",
    "data-name": "Group 88031",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.638,
    height: 63,
    viewBox: "0 0 57.638 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25595",
    "data-name": "Rectangle 25595",
    width: 57.638,
    height: 63,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88030",
    "data-name": "Group 88030",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308423",
    "data-name": "Path 308423",
    d: "M54.377,33.618H3.261V3.351A2.681,2.681,0,0,1,5.942.67H51.7a2.681,2.681,0,0,1,2.681,2.681Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308424",
    "data-name": "Path 308424",
    d: "M8.355.67H5.942A2.681,2.681,0,0,0,3.261,3.351V33.618H5.674V3.351A2.681,2.681,0,0,1,8.355.67",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308425",
    "data-name": "Path 308425",
    d: "M3.261,30.468a.872.872,0,1,1,.871-.871.871.871,0,0,1-.871.871",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308426",
    "data-name": "Path 308426",
    d: "M54.377,26.514a.67.67,0,0,1-.67-.67V3.351A2.013,2.013,0,0,0,51.7,1.34H5.942A2.013,2.013,0,0,0,3.931,3.351V25.844a.671.671,0,0,1-1.341,0V3.351A3.355,3.355,0,0,1,5.942,0H51.7a3.354,3.354,0,0,1,3.351,3.351V25.844a.67.67,0,0,1-.67.67",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308427",
    "data-name": "Path 308427",
    d: "M54.377,28.726a.872.872,0,1,1-.871.871.871.871,0,0,1,.871-.871",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25593",
    "data-name": "Rectangle 25593",
    width: 38.652,
    height: 11.841,
    transform: "translate(9.493 11.357)",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25594",
    "data-name": "Rectangle 25594",
    width: 2.145,
    height: 11.841,
    transform: "translate(9.493 11.357)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11051",
    "data-name": "Line 11051",
    y1: 11.854,
    transform: "translate(22.858 11.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308428",
    "data-name": "Path 308428",
    d: "M13.826,20.558v-6.7l4.749,3.351Z",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308429",
    "data-name": "Path 308429",
    d: "M43.752,52.558A2.244,2.244,0,0,1,41.51,54.8H24.919a1.876,1.876,0,0,1-1.877-1.876V50.883L15.015,36.042a3,3,0,0,1,1.261-3.887A2.934,2.934,0,0,1,20.26,33.32l1.754,3.173V18.344a2.929,2.929,0,0,1,5.859,0v10.2a2.8,2.8,0,1,1,5.606,0v1.84a3.014,3.014,0,1,1,6.028,0v2.635a2.932,2.932,0,0,1,5.864,0V46.9l-1.6,3.562v2.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308430",
    "data-name": "Path 308430",
    d: "M25.187,52.928l.268-2.045-8.027-14.84a3,3,0,0,1,1.261-3.888c.067-.037.135-.07.2-.1a2.919,2.919,0,0,0-2.616.1,3,3,0,0,0-1.261,3.888l8.027,14.84v2.045a1.877,1.877,0,0,0,1.877,1.877h2.145A1.877,1.877,0,0,1,25.187,52.928Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308431",
    "data-name": "Path 308431",
    d: "M43.769,49.516a.872.872,0,1,1-.872.871.87.87,0,0,1,.872-.871",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308432",
    "data-name": "Path 308432",
    d: "M42.428,54.134H24.382a2.013,2.013,0,0,0-2.01,2.011v4.844A2.013,2.013,0,0,0,24.382,63H42.428a2.013,2.013,0,0,0,2.011-2.011V56.145a2.013,2.013,0,0,0-2.011-2.011",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308433",
    "data-name": "Path 308433",
    d: "M56.968,32.949H46.039a3.6,3.6,0,0,0-5.865-2.725,3.683,3.683,0,0,0-6.143-2.576,3.471,3.471,0,0,0-5.488-1.84V23.869h19.6a.67.67,0,0,0,.67-.67V11.358a.67.67,0,0,0-.67-.671H9.493a.67.67,0,0,0-.67.671V23.2a.67.67,0,0,0,.67.67H21.344V33.9l-.5-.9a3.6,3.6,0,0,0-6.3-.048H.67a.67.67,0,0,0-.67.67v4.495a3.355,3.355,0,0,0,3.351,3.351H17.186l5.276,9.756a.67.67,0,0,0,1.159-.674l-8-14.787a2.327,2.327,0,0,1,.976-3.017,2.272,2.272,0,0,1,3.075.9l1.754,3.173a.674.674,0,0,0,1.257-.325V18.345a2.259,2.259,0,1,1,4.518,0V35.032a.67.67,0,0,0,1.341,0V28.547a2.132,2.132,0,1,1,4.265,0v7.235a.67.67,0,1,0,1.34,0v-5.4a2.345,2.345,0,0,1,4.689,0v6.866a.67.67,0,1,0,1.34,0v-4.23a2.262,2.262,0,1,1,4.523,0V46.9a.67.67,0,0,0,1.341,0V41.464h8.246a3.354,3.354,0,0,0,3.351-3.351V33.619A.67.67,0,0,0,56.968,32.949ZM22.187,16.032a3.584,3.584,0,0,0-.843,2.313v4.184H10.163v-10.5H22.187Zm2.756-1.287a3.587,3.587,0,0,0-1.415.29V12.028H47.475v10.5H28.543V18.345a3.6,3.6,0,0,0-3.6-3.6",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthNewIcon4);
export default __webpack_public_path__ + "static/media/Mental_Health_New_Icon_4.24345599a3d8f158af81a416a48c1e38.svg";
export { ForwardRef as ReactComponent };